import useSWR from "swr";
import API from "../../axios/instances/API";

const BASE_URL = "/dashboard/analytics/retail-reports/submissions/";

const fetcher = async (url) => {
  const { data } = await API.get(url);
  return data;
};

const useSingleSubmissionReport = (id) => {
  const { data, error, mutate } = useSWR(`${BASE_URL}${id}/`, fetcher, {
    revalidateOnFocus: false,
  });

  return {
    data: data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
};

export default useSingleSubmissionReport;
